import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import LoginPage from './content/pages/Login';
import { ProtectedRoute } from './components/ProtectedRoute';
import PrivacyPolicy from './content/pages/PrivacyPolicy';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages
const Insights = Loader(lazy(() => import('src/content/dashboards/Insights')));
const TermsPage = Loader(lazy(() => import('src/content/pages/TermsPage')));
const AdminSupportPage = Loader(lazy(() => import('src/content/support')));
const CorporateActionsPage = Loader(
  lazy(() => import('src/content/corporate-actions'))
);
const ActivatePage = Loader(
  lazy(() => import('src/content/pages/ActivatePage'))
);
const UserDirectoryPage = Loader(
  lazy(() => import('src/content/pages/UserDirectoryPage'))
);

// Applications
const Holdings = Loader(
  lazy(() => import('src/content/applications/Holdings'))
);
const Transactions = Loader(
  lazy(() => import('src/content/applications/Transactions'))
);
const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);
const ChangePassword = Loader(
  lazy(() => import('src/content/applications/Users/profile/ChangePassword'))
);
const CsvImport = Loader(
  lazy(() => import('src/content/applications/Users/csv-import'))
);
const TaxReport = Loader(
  lazy(() => import('src/content/applications/Reports/tax-reports'))
);

// Status
const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <LoginPage />
      },
      {
        path: '/login',
        element: <LoginPage />
      },
      {
        path: '/terms',
        element: <TermsPage />
      },
      {
        path: '/activate',
        element: <ActivatePage />
      },
      {
        path: '/privacy',
        element: <PrivacyPolicy />
      },

      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'dashboards',
    element: (
      <ProtectedRoute>
        <SidebarLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="insights" replace />
      },
      {
        path: 'insights',
        element: <Insights />
      }
    ]
  },
  {
    path: 'management',
    element: (
      <ProtectedRoute>
        <SidebarLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="holdings" replace />
      },
      {
        path: 'holdings',
        element: <Holdings />
      },
      {
        path: 'transactions',
        element: <Transactions />
      },
      {
        path: 'corporate-actions',
        element: <CorporateActionsPage />
      },
      {
        path: 'support',
        element: <AdminSupportPage />
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'csv-import',
            element: <CsvImport />
          },
          {
            path: 'tax-reports',
            element: <TaxReport />
          },
          {
            path: 'details',
            element: <UserProfile />
          },
          {
            path: 'change-password',
            element: <ChangePassword />
          },
          {
            path: 'user-directory',
            element: <UserDirectoryPage />
          }
        ]
      }
    ]
  }
];

export default routes;
